module.exports = __webpack_public_path__ + "static/assets/01df1f42be04d3a9f3a786e5615400c3.png";